import React from "react";

const FacebookIcon = () => {
  return (
    <>
       <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="35"
        // viewBox="0 0 59 59"
        viewBox="2 2 55 50"
        fill="none"
      >
        <mask
          id="mask0_3085_26464"
          style={{maskType:"luminance"}}
          maskUnits="userSpaceOnUse"
          x="15"
          y="14"
          width="30"
          height="30"
        >
          <path
            d="M44.5 14.5V43.5H15.5V14.5H44.5Z"
            fill="white"
            stroke="white"
          />
        </mask>
        <g mask="url(#mask0_3085_26464)">
          <path
            d="M33.4648 15.2489C34.7811 15.2489 36.0435 15.3175 36.8496 15.3788V18.6981H35.5C33.8908 18.6981 32.755 19.0869 32.1289 20.0165C31.8359 20.4517 31.7114 20.9284 31.6543 21.3593C31.5982 21.7826 31.5996 22.2254 31.5996 22.5985V26.4989H36.5977L35.5469 30.6981H31.5996V43.4481H27.4004V30.6981H22.9004V26.4989H27.4004V21.3983C27.4004 19.3118 28.0562 17.8 29.0811 16.8085C30.1113 15.8119 31.6104 15.2489 33.4648 15.2489Z"
            stroke="url(#paint0_linear_3085_26464)"
            strokeWidth="2"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_3085_26464"
            x1="24.7556"
            y1="-3.62465"
            x2="59.4708"
            y2="60.8789"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#1F8D82" />
            <stop offset="1" stopColor="#88C5BF" />
          </linearGradient>
        </defs>
      </svg>
    </>
  );
};

export default FacebookIcon;
